import { render, staticRenderFns } from "./verify-login.vue?vue&type=template&id=45057e7b&"
import script from "./verify-login.vue?vue&type=script&lang=js&"
export * from "./verify-login.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports